import { Alert, IconButton } from '@chakra-ui/react'
import { XIcon } from 'lucide-react'

type CustomAlertProps = {
  status: 'info' | 'warning' | 'success' | 'error'
  title: string
  handleClose: () => void
  description: string
}

export const CustomAlert = ({
  status,
  handleClose,
  title,
  description,
}: CustomAlertProps) => {
  return (
    <Alert.Root
      data-state="open"
      _open={{
        animationName: 'fade-in, scale-in',
        animationDuration: '300ms',
      }}
      status={status}
      borderRadius={'none'}
      boxShadow={'sm'}
    >
      <Alert.Indicator />
      <Alert.Content
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <div>
          <Alert.Title>{title}</Alert.Title>
          <Alert.Description>{description}</Alert.Description>
        </div>
        <IconButton bg={'transparent'} color={'fg.muted'} onClick={handleClose}>
          <XIcon></XIcon>
        </IconButton>
      </Alert.Content>
    </Alert.Root>
  )
}
